import moment, { now } from "moment";
import React, { useRef, useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import * as XLSX from "xlsx";
import http from "../../utils/http";

const CreateTransactionForm = ({
  onFormClose,
  onFormSubmit,
  onFormPushing,
  onFormCompleted,
}) => {
  const inputRef = useRef(null);
  const [file, setFile] = useState(null);

  useEffect(() => {
    // Focus the input on load
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
  };

  const createTransactions = async (transactions) => {
    try {
      const getResp = await http.post("/transactions/creates", transactions);
      console.log("getCard ", getResp.data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const readExcel = (file) => {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
    
      fileReader.onload = (e) => {
      const bufferArray = e.target.result;
      const wb = XLSX.read(bufferArray, {
        type: "buffer",
        cellDates: true,
        cellNF: false,
        cellText: false,
      });
    
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
    
      // Map the custom header to JSON header
      const data = XLSX.utils.sheet_to_json(ws, {
        header: ["kiosk_id", "employee_id", "receive_day","shift_1","shift_2","shift_3","shift_office"], // JSON keys
        raw: false, // Ensure dates are read as strings
        dateNF: 'dd/mm/yyyy' // Specify the date format
      });
    
      // Rename headers for human-readable labels in the original Excel
      const headers = {
        kiosk_id: "Mã máy",
        employee_id: "Mã nhân viên",
        receive_day: "Ngày nhận",
        shift_1 : "Ca 1",
        shift_2 : "Ca 2",
        shift_3 : "Ca 3",
        shift_office : "Hành chính",
      };
    
      // Transform the first row to use custom headers
      data[0] = Object.fromEntries(
        Object.keys(data[0]).map((key) => [headers[key], data[0][key]])
      );
    
      resolve(data);
      };
    
      fileReader.onerror = (error) => {
      reject(error);
      };
    });
  
    promise.then(async (inputRows) => {
      let createArr = [];
      console.log("rows : ", inputRows);
      inputRows.forEach((row) => {
        let shifts = [];
        if (row.shift_1 && row.shift_1=="x")
          shifts.push("Ca 1")
        if (row.shift_2 && row.shift_2=="x")
          shifts.push("Ca 2")
        if (row.shift_3 && row.shift_3=="x")
          shifts.push("Ca 3")
        if (row.shift_office && row.shift_office=="x")
          shifts.push("Hành chính")
        shifts.forEach(shift => {
            createArr.push({
          licensePlate: "0",
          paymentMethod: "NONE",
          paymentAmount: 0,
          kioskId: row.kiosk_id,
          userId: ("" + row.employee_id).trim(),
          checkInTime: moment(row.receive_day, "DD/MM/YYYY").valueOf(),
          zmaTrans: shift.trim()
            });
        });
        
      });
      console.log("Create ", createArr);
      createTransactions(createArr);
    });
  };

  return (
    <div>
      <div className="modal-overlay">
        <div className="modal-content">
          <h3>Nạp dữ liệu nhận:</h3>

          <div className="form-group">
            <label>Chọn file excel:</label>
            <input
              type="file"
              name="excelFile"
              ref={inputRef}
              className="form-control"
              accept=".xlsx, .xls, .csv"
              onChange={handleFileChange}
            />
            <div className="file-link">
              <a
                href="/milk_machine_template.xlsx"
                target="_blank"
                rel="noopener noreferrer"
              >
                Tải xuống File Excel mẫu
              </a>
            </div>
          </div>

          <div className="modal-actions">
            <button
              className="btn btn-secondary"
              onClick={() => {
                onFormClose();
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-success"
              onClick={() => {
                onFormSubmit();
                readExcel(file); // Pass the selected file to the parent
              }}
              disabled={!file} // Disable the button if no file is selected
            >
              Submit
            </button>
          </div>
        </div>
      </div>
      {/* Styles */}
      <style jsx>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }
        .modal-content {
          background: white;
          padding: 20px;
          border-radius: 8px;
          width: 500px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        }
        .form-group {
          margin-bottom: 25px;
        }
        .form-group label {
          display: block;
          font-weight: bold;
          margin-bottom: 5px;
        }
        .form-control {
          width: 100%;
          padding: 8px;
          box-sizing: border-box;
        }
        .file-link {
          margin-top: 10px;
        }
        .file-link a {
          color: rgb(58, 194, 121);
          text-decoration: underline;
          cursor: pointer;
        }
        .modal-actions {
          display: flex;
          justify-content: flex-end;
          gap: 10px;
        }
        .btn {
          padding: 8px 12px;
          cursor: pointer;
        }
        .btn-primary {
          background: #007bff;
          color: white;
          border: none;
        }
        .btn-success {
          background: #28a745;
          color: white;
          border: none;
        }
        .btn-secondary {
          background: #6c757d;
          color: white;
          border: none;
        }
        .btn:disabled {
          background: #ccc;
          cursor: not-allowed;
        }
      `}</style>
    </div>
  );
};

export default CreateTransactionForm;
